import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarAtualizarSms as revelarAtualizarSmsDespacho,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import { useGlobal } from '../../../stores/useGlobal.js'
import { formatarData } from '../../../utils/formatadorDataTabela'
import utilsSms from '../../../utils/sms'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import Table from '../../Table/index.jsx'

import ConversasSms from './conversas/conversas'
import EnviarSms from './enviarSms/enviarSms'
import RelatorioEnvioSms from './relatorioEnvioSms/RelatorioEnvioSms'

import '../../../css/painelSms/smsMensagens/tabela.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let itensVar = []
const valorLimite = 50

const TableprimaryKey = 'cd_sms_envio'

function Grid(props) {
  const { setMostrarNotificacao } = useGlobal()
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  // const [envioSelecionado, setEnvioSelecionado] = useState([])
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [cdSmsContaUsuario, setCdSmsContaUsuario] = useState(undefined)
  const [saldoReal, setSaldoReal] = useState(0)
  const [itensSelecionados, setItensSelecionados] = useState()

  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  const [spinAtivo, setSpinAtivo] = useState(false)

  const despacho = useDispatch()
  let filtros = useSelector((state) => state.filtrosState.filtros)

  let revelarAtualizarSms = useSelector(
    (state) => state.smsState.revelarAtualizarSms
  )
  let revelarEnviarSmsModulo = useSelector(
    (state) => state.smsState.revelarEnviarSmsModulo
  )
  let revelarVerConversasSms = useSelector(
    (state) => state.smsState.revelarVerConversasSms
  )
  let revelarRelatorioEnvioSms = useSelector(
    (state) => state.smsState.revelarRelatorioEnvioSms
  )

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  // USABILIDADE
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)
  let temFiltros = false

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(465) // 'smsMensagensTabela'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function carregarSaldo() {
    if (
      cdSmsContaUsuario !== undefined &&
      cdSmsContaUsuario !== false &&
      cdSmsContaUsuario !== ''
    ) {
      const query = utilsSms.getNewQueryGet('paginaAtual=0&carregarLimit=1')
      await api_gateway
        .get('/m1/consultar/smsExtrato?' + query)
        .then(function (response) {
          if (
            response.data.status == 200 &&
            response.data.dados[0] != undefined
          ) {
            setSaldoReal(response.data.dados[0].n0_saldo_real)
          } else {
            setSaldoReal(0)
          }
        })
    }
  }

  useEffect(() => {
    function checarFiltros() {
      if (filtros.vazio === 'vazio') {
        temFiltros = false
      } else {
        temFiltros = true
      }
    }
    checarFiltros()
  }, [filtros])

  useEffect(() => {
    if (props.filtros.vazio) {
      despacho(revelarBarraFiltragem(false))
      if (!filtros.vazio) {
        despacho(mudarFiltros({ vazio: 'vazio' }))
      }
      despacho(limpadorFiltros(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function atualizarEnviosRespostas() {
      if (revelarAtualizarSms === true) {
        setSpinAtivo(true)
        await api_gateway.post('/m1/consultar/sincronizacaoSmsStatus', {
          cd_sms_conta_usuario: utilsSms.getCdSmsContaUsuario(
            'cd_sms_conta_usuario'
          )
        })
        await api_gateway
          .post('/m1/consultar/sincronizacaoSmsResposta')
          .then(() => {
            handleMensagemSucesso()
          })
          .catch((error) => {
            if (error.response.request.status === 400) {
              setMostrarNotificacao({
                show: true,
                type: 'error',
                title: 'Erro',
                message: 'Não foi possível atualizar as mensagens.'
              })
            }

            setSpinAtivo(false)
          })
          .finally(() => {
            despacho(revelarAtualizarSmsDespacho(false))
          })
      }
    }
    atualizarEnviosRespostas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revelarAtualizarSms])

  useEffect(() => {
    setSpinAtivo(true)

    //despacho redux
    despacho(mudarManejador('envioSms'))
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(true))
    async function carregarTabela() {
      setCdSmsContaUsuario(utilsSms.getCdSmsContaUsuario())
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && !temFiltros) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()

          const query = utilsSms.getNewQueryGet(
            'paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&buscar=' +
              conteudoBusca
          )
          const { data } = await api_gateway.get(
            '/m1/consultar/smsEnvio/tabela?' + query
          )
          inserirData(data.dados)
        }
      } else if (temFiltros) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = utilsSms.getNewBodyPost({
          paginaAtual: contador,
          carregarLimit: valorLimite,
          filtros: filtros
        })

        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post('/m1/filtrar/smsEnvio', dados)
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          let query = utilsSms.getNewQueryGet(
            'paginaAtual=' + contador + '&carregarLimit=' + valorLimite
          )

          const { data } = await api_gateway.get(
            '/m1/consultar/smsEnvio/tabela?' + query
          )
          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginaAtual, conteudoBusca, renderizar, filtros])
  carregarSaldo()

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual && props.filtros.vazio) {
      const query = utilsSms.getNewQueryGet(
        'contar=true&buscar=' + conteudoBusca
      )
      apiData = await api_gateway.get('/m1/consultar/smsEnvio/tabela?' + query)
    } else {
      const dados = utilsSms.getNewBodyPost({
        paginaAtual: contador,
        carregarLimit: valorLimite,
        filtros: filtros,
        contar: true
      })
      apiData = await api_gateway.post('/m1/filtrar/smsEnvio', dados)
    }
    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
    itensVar = arrayItens
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      setRenderizar(!renderizar)
      restaurarConfigsIniciaisPagina()
    }
  }

  const colunas = [
    {
      dataField: 'cd_sms_envio',
      text: 'ID',
      hidden: true,
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'dt_created_at',
      headerClasses: 'nao-selecionavel',
      text: 'Data',
      sort: true,
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    },
    {
      dataField: 'n0_msisdn',
      headerClasses: 'nao-selecionavel',
      text: 'Linha',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ds_sms_status',
      headerClasses: 'nao-selecionavel',
      text: 'Status',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ds_mensagem',
      headerClasses: 'nao-selecionavel',
      text: 'Mensagem',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'qtd_respostas',
      headerClasses: 'nao-selecionavel',
      text: 'Resposta',
      sort: true,
      formatter: (cell, row) => {
        if (row.cd_sms_tipo == 2)
          return (
            <p className="fonte-cor-1 label-tabela-1">
              {cell > 0 ? 'Recebida' : 'Não Recebida'}
            </p>
          )
        else return <p className="fonte-cor-1 label-tabela-1">-</p>
      }
    }
  ]

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados(row)
      despacho(desabilitarAcoes(false))
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <div className="container-tela">
      {saldoReal !== 0 && (
        <div id="smsTabela">
          <span className="label-valor-cancelamento-reposicao-1 fonte-cor-1 negrito">
            Créditos disponíveis:{' '}
          </span>
          <span className="label-valor-cancelamento-reposicao-2 fonte-cor-2 negrito">
            {saldoReal}
          </span>
        </div>
      )}
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarVerConversasSms === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <ConversasSms
              setRenderizar={setRenderizar}
              renderizar={renderizar}
              cd_sms_conta_usuario={cdSmsContaUsuario}
              msisdn={itensSelecionados.n0_msisdn}
            />
          </div>
        </div>
      )}
      {revelarEnviarSmsModulo === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <EnviarSms setRenderizar={setRenderizar} renderizar={renderizar} />
          </div>
        </div>
      )}
      {revelarRelatorioEnvioSms === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <RelatorioEnvioSms
              setRenderizar={setRenderizar}
              renderizar={renderizar}
            />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="As Mensagens foram atualizadas."
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}

//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(Grid))
